module.exports = __webpack_public_path__ + "img/agave_1.15d1764c.jpeg";